import { graphql } from 'react-relay';

/**
 * Added item to initial query to be able to pull
 * redirectPdp_item on server to determine if we need to redirect.
 * Do not add other framments to item in this query
 */

export const pdpRespRootQuery = graphql`
    query pdpRespRootQuery(
        $filterOutLessSellableItemsTest: Boolean
        $isClient: Boolean!
        $itemId: String!
        $itemIds: [String]!
        $userId: String = ""
        $userIds: [String]
        $fetchUser: Boolean!
        $relationshipUserIds: [String]!
        $followSearchPages: [String]
        $fetchFollowSearch: Boolean!
        $isTrade: Boolean!
        $isMultiSku: Boolean!
        $fetchPdp: Boolean!
    ) {
        viewer {
            ...PdpRespLayout_viewer
            ...getLanguageAnnotationsAndDomainLinksPdp_viewer
            item(itemId: $itemId) {
                ...redirectPdp_item
            }
        }
    }
`;

export const pdpRespVariables = {
    isClient: false,
    itemId: null,
    itemIds: [],
    newAndCustomSplitTest: false,
    filterOutLessSellableItemsTest: false,
    selectedItemIds: [],
    userId: '',
    userIds: [],
    fetchUser: false,
    loadPortfolioData: false,
    relationshipUserIds: [],
    followSearchPages: null,
    fetchFollowSearch: false,
    isTrade: false,
    isMultiSku: false,
    fetchPdp: true,
};
